var _defs, _rect, _circle, _g, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFarnesene(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a43c3875-22ff-4e89-aed8-6ddf7dcf4462",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b43755fe-454a-4be1-8e28-9e89706f8ffe{fill:#fff;}.b06e1071-f585-4b2a-b221-fb8dc5b52833{fill:#a9b755;}.ee0d7d0f-852b-4ee2-9084-b2d1531bee79{isolation:isolate;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b43755fe-454a-4be1-8e28-9e89706f8ffe",
    width: 500,
    height: 500
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b06e1071-f585-4b2a-b221-fb8dc5b52833",
    cx: 249.9,
    cy: 197.1,
    r: 98.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ee0d7d0f-852b-4ee2-9084-b2d1531bee79"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b06e1071-f585-4b2a-b221-fb8dc5b52833",
    d: "M119.9,353.7h21.9v5.8H126.4v8.8h12.9v5.9H126.4v12.5h-6.5Z",
    transform: "translate(-0.1 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b06e1071-f585-4b2a-b221-fb8dc5b52833",
    d: "M153.4,353.7h6.3l12.3,33h-6.8l-2.3-6.6H150.2l-2.2,6.6h-6.8Zm7.6,20.8-4.4-12.9h-.1l-4.4,12.9Z",
    transform: "translate(-0.1 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b06e1071-f585-4b2a-b221-fb8dc5b52833",
    d: "M176.2,353.7h12.5c8,0,11.5,4.7,11.5,11,0,5-2.3,8.5-6.9,10l8.3,12.1h-7.8l-7.4-11.3h-3.8v11.3h-6.5V353.7Zm11.3,15.9c4,0,6-2,6-5.1s-2-5.1-5.8-5.1h-5v10.1h4.8Z",
    transform: "translate(-0.1 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b06e1071-f585-4b2a-b221-fb8dc5b52833",
    d: "M206.7,353.7h6.4L228,376h.1V353.7h6.5v33H228l-14.7-21.8h-.1v21.8h-6.5Z",
    transform: "translate(-0.1 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b06e1071-f585-4b2a-b221-fb8dc5b52833",
    d: "M241.7,353.7h21.1v5.8H248.1v8h11.7v5.7H248.1v7.7h15.6v5.8H241.6v-33Z",
    transform: "translate(-0.1 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b06e1071-f585-4b2a-b221-fb8dc5b52833",
    d: "M267.5,381.9l4-4.8a11.38,11.38,0,0,0,8.2,4.1c3.2,0,4.7-1.4,4.7-3.5,0-2.4-1.7-3.3-5.7-4.7-5-1.7-10-4-10-10.3,0-5.3,4.7-9.4,10.6-9.4a17.5,17.5,0,0,1,11.2,4.2l-3.8,4.9c-2.7-2.2-5.2-3.3-7.2-3.3-2.3,0-4,1.2-4,3.3s1.8,2.9,5.6,4.4c5.7,2.2,10.3,3.7,10.3,10.1,0,7.3-6.4,10.2-11.7,10.2A16.67,16.67,0,0,1,267.5,381.9Z",
    transform: "translate(-0.1 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b06e1071-f585-4b2a-b221-fb8dc5b52833",
    d: "M296.6,353.7h21.1v5.8H303v8h11.7v5.7H303v7.7h15.6v5.8H296.5v-33Z",
    transform: "translate(-0.1 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b06e1071-f585-4b2a-b221-fb8dc5b52833",
    d: "M324.5,353.7h6.4L345.7,376h.1V353.7h6.5v33h-6.6L331,364.9h0v21.8h-6.5Z",
    transform: "translate(-0.1 -0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b06e1071-f585-4b2a-b221-fb8dc5b52833",
    d: "M359.5,353.7h21.1v5.8H366v8h11.7v5.7H366v7.7h15.6v5.8H359.5Z",
    transform: "translate(-0.1 -0.1)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b43755fe-454a-4be1-8e28-9e89706f8ffe",
    d: "M208.2,150.9v39.8h10.3v7.6H208.2v48.3H198.1V142.4h23.4v8.5Z",
    transform: "translate(-0.1 -0.1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b43755fe-454a-4be1-8e28-9e89706f8ffe",
    d: "M247.4,218.4h-9.1l-2.5,28.2h-8.6l9.5-104.2h12.8l10.1,104.2H250Zm-8.5-7.6h7.7L243,170.4h-.4Z",
    transform: "translate(-0.1 -0.1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b43755fe-454a-4be1-8e28-9e89706f8ffe",
    d: "M299.3,184.4c0,3.2-.5,5.5-1.5,7.1a7.33,7.33,0,0,1-3.7,3.1,6.48,6.48,0,0,1,3.7,2.9c1,1.5,1.5,3.9,1.5,7.1v24.3a97.16,97.16,0,0,0,.6,13.2,19,19,0,0,0,1,4.5H290.8c-.7-1.2-1.1-3.2-1.3-6s-.3-6.7-.3-11.8V205.4q0-7.2-3.6-7.2h-5.4v48.3H270.1V142.4H286a12.91,12.91,0,0,1,9.3,3.7q3.9,3.6,3.9,10.8v27.5Zm-13.7,6.4c2.4,0,3.6-2.3,3.6-7V158.3q0-3.9-1.2-5.7a3.53,3.53,0,0,0-3-1.8h-4.8v39.9h5.4Z",
    transform: "translate(-0.1 -0.1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarnesene);
export default __webpack_public_path__ + "static/media/FARNESENE.213b5fc31af5c3c1a06b58a9b5c06ba5.svg";
export { ForwardRef as ReactComponent };